module.exports = __webpack_public_path__ + "static/test2-b16936a3221354b8968a3696265259f0.jpg";